import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Controller, useForm } from 'react-hook-form';
import { ListAllIntershipsOfTheMonthResponseDto, ReadPersonDto } from '@/api.types';
import { SelectGenerico } from '@/shared/components/forms/SelectGenerico';
import { changeResponsible } from '../../attendance-sheet.service';
import { readPerson } from '@/modules/people/person.service';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';

type Formulario = {
  responsavel?: ReadPersonDto;
};

interface IMyProps {
  show: boolean;
  folha: ListAllIntershipsOfTheMonthResponseDto;
  handleHide: (e: | React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLButtonElement> | HTMLElement) => void;
}

export default function ModalResponsavel({ show, handleHide, folha }: IMyProps) {

  const [executing, setExecuting] = useState<boolean>()
  const [pessoas, setPessoas] = useState<ReadPersonDto[]>([])

  const { control, handleSubmit, reset } = useForm<Formulario>({
    defaultValues: {
      responsavel: folha.responsavel,
    },
  });

  useEffect(() => {
    readPerson({ skip: 0, take: 1000, comEstagiario: true, orderBy: 'ASC' })
      .then((res) => {
        setPessoas(res[0].filter(a => !a.estagiario))
      })
      .catch()
  })

  useEffect(() => {
    reset({
      responsavel: folha.responsavel,
    });
  }, [folha, reset]);


  const onSubmit = (data: Formulario) => {
    setExecuting(true)

    changeResponsible(folha.folha.id, data.responsavel ? data.responsavel.id : "0")
      .then((res) => {
        toast.info(String(res))
      })
      .catch((res) => {
        toast.error(String(res))
      })
      .finally(() => {
        setExecuting(false)
      })
  };


  return (
    <Modal show={show} aria-labelledby="contained-modal-title-vcenter" centered onExit={handleHide}>
      <Modal.Header closeButton={false}>
        <Modal.Title id="contained-modal-title-vcenter">
          Definição de Responsável
        </Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit(onSubmit)}>

        <Modal.Body>
          <p>Defina quem é o responsável por essa folha de frequência:</p>
          <Controller
            name="responsavel"
            control={control}
            render={({ field }) => (
              <SelectGenerico
                id="responsavel"
                name="responsavel"
                value={field.value}
                onChange={field.onChange}
                onBlur={field.onBlur}
                items={pessoas}
                getOptionLabel={(p) => p.nome!}
                getOptionValue={(p) => p.id}
                isClearable={true}
              />
            )}
          />

        </Modal.Body>
        <Modal.Footer className="text-left">
          <Button
            variant="primary"
            type='submit'
            className="btn-success text-left"
            disabled={executing}>
            {executing ? 'Aguarde...' : 'Definir'}
          </Button>
          <Button variant="secondary" onClick={handleHide}>
            Fechar
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
